import React from 'react';

import { Checkbox, Flex, Space, Tooltip } from 'antd-v5';
import { MdClose } from 'react-icons/md';
import { ScoutRankTag, Text } from 'scouting-ui/lib';
import { cssVars } from 'scouting-ui/lib/variables';

import type {
  MeritBadgeUserRequirements,
  RosterYouthMember,
} from '@appTypes/esb';
import { ConditionalRender, PersonAvatar } from '@shared/components';
import { getPreferredName } from '@shared/utils/preferredName';
import { getLatestRankApproved } from '@shared/utils/youthModel';

import styles from './BulkMBCAssignPage.module.scss';
import MeritBadgeInfoTag from './MeritBadgeInfoTag';

export const YouthItem: React.FC<{
  youth: RosterYouthMember;
  mbRequirements?: MeritBadgeUserRequirements;
  checked: boolean;
  onSelect: (checked: boolean) => void;
  disabled?: boolean;
  errors?: string[];
}> = props => {
  const { youth, disabled, errors, checked, onSelect, mbRequirements } = props;
  const lastRank = getLatestRankApproved(youth);
  return (
    <Flex vertical align="flex-start" gap={4} className={styles.youthRow}>
      <Checkbox
        className={styles.youthCheckbox}
        disabled={disabled}
        checked={checked}
        onChange={item => {
          const checked = item.target.checked;

          onSelect(checked);
        }}
      >
        <Flex align="center" gap="small">
          <PersonAvatar
            src={youth.pictureUrl}
            isAdult={false}
            gender={youth.gender}
          />
          <Text
            font="buttons-medium"
            color={disabled ? 'color-text-disabled' : 'color-info'}
          >
            {getPreferredName(youth)}
          </Text>
          <ConditionalRender value={!!errors?.length}>
            <Tooltip
              title={
                <ol className={styles.errorList}>
                  {errors?.map(error => (
                    <li key={error}>
                      <Text color="color-white" font="body-caption">
                        {error}
                      </Text>
                    </li>
                  ))}
                </ol>
              }
            >
              <MdClose
                className={styles.tagIcon}
                color={cssVars['color-error']}
              />
            </Tooltip>
          </ConditionalRender>
        </Flex>
      </Checkbox>
      <Space align="center" size={'small'} className={styles.tagContainer}>
        <ScoutRankTag rank={lastRank?.rank} />
        <MeritBadgeInfoTag requirements={mbRequirements} />
      </Space>
    </Flex>
  );
};
